module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "flex bg-white br3 new-shadow-theme custom-padding responsive-box",
    class: [
      !_vm.showCustomWidth && 'mr5',
      _vm.showCustomWidth && 'custom-width',
      !_vm.showPlans && 'plans-hidden'
    ]
  }, [_c('div', {
    staticClass: "flex flex-column w-100 responsive-device"
  }, [_c('div', {
    staticClass: "cera-round-pro-medium f4 mb4 fw5"
  }, [_vm._v("Select Your Phone" + _vm._s(_vm.selectedPhones.length > 1 ? 's' : ''))]), _vm._v(" "), _c('div', {
    staticClass: "inter mb1 f6 self-center items-center justify-start text-container"
  }, [_vm._v("\n      " + _vm._s(_vm.selectPhoneDescription) + "\n    ")]), _vm._v(" "), (_vm.selectedPhones.length > 1) ? _c('div', {
    staticClass: "inter mv1 f6 self-center items-center text-container justify-start flex"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "alt": "Users",
      "src": "/static/appicons/Users.svg"
    }
  }), _vm._v("If registering more than one plan, each\n      person will have their own account and login tied to their mobile number.\n    ")]) : _vm._e(), _vm._v(" "), (!_vm.isPhoneOnly) ? _c('div', {
    staticClass: "inter mv1 f6 self-center items-center text-container justify-start flex"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "alt": "Info",
      "src": "/static/appicons/Info.svg"
    }
  }), _vm._v(_vm._s(_vm.selectPhoneVerbiage) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex flex-row flex-wrap w-100 justify-between cards mt3"
  }, [_vm._l((_vm.selectedPhones), function(phone, index) {
    return _c('edit-device', {
      key: phone.id,
      attrs: {
        "allMakes": _vm.allMakes,
        "filterModelsBySelectedMake": _vm.filterModelsBySelectedMake,
        "isFamily": _vm.isFamily,
        "isPhoneOnly": _vm.isPhoneOnly,
        "phoneIndex": index,
        "phonesNumber": _vm.selectedPhones.length,
        "removeItem": _vm.removePhone,
        "selectedPhone": phone,
        "setIsAdult": _vm.setIsAdult,
        "setMake": _vm.setMake,
        "setModel": _vm.setModel
      }
    })
  }), _vm._v(" "), (_vm.isOddPhones && !_vm.isParnertId) ? _c('add-phone', {
    attrs: {
      "discount": _vm.selectedPhones.length === 1,
      "onClick": _vm.addPhone
    }
  }) : _vm._e()], 2), _vm._v(" "), ((!_vm.isOddPhones && !_vm.isParnertId)) ? _c('add-phone', {
    staticClass: "outside",
    attrs: {
      "onClick": _vm.addPhone
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0f61e26c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f61e26c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/registration/multiplePhonePlan/selectBox/SelectDevices.vue
// module id = 794
// module chunks = 0